import { combineReducers } from 'redux';

import { dashboard } from "./dashboard/dashboard.reducer";


export const deals = combineReducers({    
    dashboard
});
